import React, { useState } from "react";

const dataList = [
  {
    title: "Numbness tingling",
    options: ["Thigh", "Knee", "Leg", "Ankle", "Foot", "Groin", "Sole"],
    name: "numbnessTingling",
    hasSideSelection: true,
  },
  {
    title: "Weakness in Neck and Leg",
    options: [
      "Shoulder",
      "Arm",
      "Forearm",
      "Hand",
      "Fingers",
      "Thigh",
      "Knee",
      "Leg",
      "Ankle",
      "Foot",
      "Drag your feet",
      "Buckle your knees",
      "Get cramps in your legs",
      "Increased numbness and weakness",
    ],
    name: "weaknessInNeck",
  },
  {
    title: "Joint Swelling/Stiffness",
    options: ["Hip", "Knee", "Foot Joints", "Ankle", "Hand Joints"],
    name: "joinSwellingStiffness",
    hasSideSelection: true,
  },
  {
    title: "Fever Chills",
    options: ["Yes", "No"],
    name: "feverChills",
  },
  {
    title: "Morning Stiffness in back",
    options: ["Yes", "No"],
    name: "morningStiffnessInBack",
  },
  {
    title: "Loss of Bladder Control",
    options: ["Yes", "No"],
    name: "lossOfBladderControl",
  },
  {
    title: "Loss of bowel Control",
    options: ["Yes", "No"],
    name: "lossOfBowelControl",
  },
  {
    title: "Balance Related Problems",
    options: ["Yes", "No"],
    name: "balanceRelatedProblems",
  },
  {
    title: "Other",
    options: [],
    name: "otherAssociatedSymptoms",
    hasTextField: true,
    textFieldOnly: true,
  },
];

export const AssociatedSymptoms = ({
  setPatientMedicationInfo,
  patientMedicationInfo,
}) => {
  const [openIndex, setOpenIndex] = useState(null);
  const [haveDisabilityForPain, setHaveDisabilityForPain] = useState("No");

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const handleOnChange = (e) => {
    const { name, value } = e.target;
    
    // Check if this is a checkbox field (multi-select)
    // These fields should allow multiple selections
    const checkboxFields = ["numbnessTingling", "weaknessInNeck", "joinSwellingStiffness"];
    
    if (e.target.type === "checkbox" && checkboxFields.includes(name)) {
      // Handle checkbox (multi-select) - add/remove from array
      const currentValue = patientMedicationInfo[name];
      const currentArray = Array.isArray(currentValue) ? currentValue : [];
      const isChecked = currentArray.includes(value);
      
      setPatientMedicationInfo({
        ...patientMedicationInfo,
        [name]: isChecked
          ? currentArray.filter((item) => item !== value) // Remove if already checked (uncheck)
          : [...currentArray, value], // Add if not checked (check)
      });
    } else {
      // Handle radio button (single select) - for Yes/No questions
      setPatientMedicationInfo({
        ...patientMedicationInfo,
        [name]: value,
      });
    }
  };
  return (
    <>
      <div className="flex  justify-between gap-8 mb-5">
        <div className="2xl:w-[60%] xl:w-[60%] lg:w-[60%] md:w-[80%] w-full bg-white shadow-sm p-5 rounded flex flex-col gap-10">
          <div className="mb-2 flex flex-col gap-7 p-6  bg-whit shado border-b border-[#d4d4d4]">
            <p className="font-mainFont font-[600] 2xl:text-[1.3vw] xl:text-[1.3vw] lg:text-[1.3vw] md:text-[1.3vw] text-[3.3vw] text-white">
              Do you have any of the following symptoms?
            </p>
            <div className="flex justify-start items-center gap-4">
              <button
                onClick={() => {
                  setPatientMedicationInfo({
                    ...patientMedicationInfo,
                    disabilityDueToPain: "Yes",
                  });
                }}
                className={`text-[#333333] ${
                  patientMedicationInfo.disabilityDueToPain === "Yes"
                    ? "text-white BTNGradientBg"
                    : "text-black bg-white"
                }  px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[4vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper`}
              >
                Yes
              </button>
              <button
                onClick={() => {
                  setHaveDisabilityForPain("No");
                  setPatientMedicationInfo({
                    ...patientMedicationInfo,
                    disabilityDueToPain: "No",
                  });
                  // setPatientMedicationInfo({
                  //   ...patientMedicationInfo,
                  //   takingBloodThinner: "No",
                  // });
                }}
                className={`text-[#333333]   px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[4vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper ${
                  patientMedicationInfo.disabilityDueToPain === "No"
                    ? "text-white BTNGradientBg"
                    : "text-black bg-white"
                }`}
              >
                No
              </button>
            </div>
          </div>

          {patientMedicationInfo.disabilityDueToPain === "Yes" && (
            <>
              {dataList.map((list, index) => (
                <AccordionItem
                  key={index}
                  index={index}
                  title={list.title}
                  options={list.options}
                  isOpen={openIndex === index}
                  onToggle={handleToggle}
                  name={list.name}
                  handleOnChange={handleOnChange}
                  patientMedicationInfo={patientMedicationInfo}
                  hasSideSelection={list.hasSideSelection}
                  hasOtherOption={list.hasOtherOption}
                  hasTextField={list.hasTextField}
                  textFieldOnly={list.textFieldOnly}
                  setPatientMedicationInfo={setPatientMedicationInfo}
                />
              ))}
            </>
          )}
        </div>
      </div>
    </>
  );
};

const AccordionItem = ({
  title,
  options,
  isOpen,
  index,
  onToggle,
  name,
  handleOnChange,
  patientMedicationInfo,
  hasSideSelection,
  hasOtherOption,
  hasTextField,
  textFieldOnly,
  setPatientMedicationInfo,
}) => {
  // Parse existing value to extract body part, side, and other text
  const parseValue = (value) => {
    if (!value) return { bodyPart: null, side: null, otherText: null };
    
    // Check for "Other: [text]" format
    const otherMatch = value.match(/^Other:\s*(.+)$/);
    if (otherMatch) {
      return { bodyPart: "Other", side: null, otherText: otherMatch[1].trim() };
    }
    
    // Check for "BodyPart (Side)" format
    const sideMatch = value.match(/^(.+?)\s*\((.+?)\)$/);
    if (sideMatch) {
      return { bodyPart: sideMatch[1].trim(), side: sideMatch[2].trim(), otherText: null };
    }
    
    // Old format (just body part, no side)
    return { bodyPart: value, side: null, otherText: null };
  };

  // Check if this is a checkbox field (multi-select)
  const isCheckboxField = ["numbnessTingling", "weaknessInNeck", "joinSwellingStiffness"].includes(name);
  
  // For checkbox fields, get all selected body parts
  let selectedBodyParts = [];
  if (isCheckboxField && Array.isArray(patientMedicationInfo[name])) {
    selectedBodyParts = patientMedicationInfo[name].map(val => {
      const match = val.match(/^(.+?)\s*\((.+?)\)$/);
      return match ? match[1].trim() : val;
    });
  }
  
  // For radio fields, use existing parseValue logic
  const { bodyPart: selectedBodyPart, side: selectedSide, otherText } = isCheckboxField 
    ? { bodyPart: null, side: null, otherText: null }
    : parseValue(patientMedicationInfo[name]);
  
  const sideOptions = ["Right", "Left", "Both"];
  const textFieldName = `${name}OtherText`;

  const handleBodyPartChange = (bodyPart, isCheckbox = false) => {
    // Check if this is a checkbox field (multi-select)
    const isCheckboxField = ["numbnessTingling", "weaknessInNeck", "joinSwellingStiffness"].includes(name);
    
    if (isCheckboxField && isCheckbox) {
      // Handle checkbox (multi-select) - add/remove from array
      const currentValue = patientMedicationInfo[name];
      const currentArray = Array.isArray(currentValue) ? currentValue : [];
      
      // Extract body parts from existing values (handle "BodyPart (Side)" format)
      const existingBodyParts = currentArray.map(val => {
        const match = val.match(/^(.+?)\s*\((.+?)\)$/);
        return match ? match[1].trim() : val;
      });
      
      const isChecked = existingBodyParts.includes(bodyPart);
      
      if (isChecked) {
        // Remove this body part (and its side if any)
        const filtered = currentArray.filter(val => {
          const match = val.match(/^(.+?)\s*\((.+?)\)$/);
          const bp = match ? match[1].trim() : val;
          return bp !== bodyPart;
        });
        setPatientMedicationInfo({
          ...patientMedicationInfo,
          [name]: filtered,
        });
      } else {
        // Add this body part (without side initially)
        setPatientMedicationInfo({
          ...patientMedicationInfo,
          [name]: [...currentArray, bodyPart],
        });
      }
    } else {
      // Handle radio button (single select) - original logic
      if (bodyPart === "Other") {
        setPatientMedicationInfo({
          ...patientMedicationInfo,
          [name]: "Other",
          [textFieldName]: otherText || "",
        });
      } else {
        setPatientMedicationInfo({
          ...patientMedicationInfo,
          [name]: bodyPart,
          [textFieldName]: "",
        });
      }
    }
  };

  const handleSideChange = (side, bodyPart) => {
    // Check if this is a checkbox field
    const isCheckboxField = ["numbnessTingling", "weaknessInNeck", "joinSwellingStiffness"].includes(name);
    
    if (isCheckboxField) {
      // For checkbox fields, update the specific body part with side
      const currentArray = Array.isArray(patientMedicationInfo[name]) ? patientMedicationInfo[name] : [];
      const combinedValue = `${bodyPart} (${side})`;
      
      // Remove old value for this body part (with or without side)
      const filtered = currentArray.filter(val => {
        const match = val.match(/^(.+?)\s*\((.+?)\)$/);
        const bp = match ? match[1].trim() : val;
        return bp !== bodyPart;
      });
      
      // Add new value with side
      setPatientMedicationInfo({
        ...patientMedicationInfo,
        [name]: [...filtered, combinedValue],
      });
    } else {
      // For radio fields, combine body part + side
      if (selectedBodyPart && selectedBodyPart !== "Other") {
        const combinedValue = `${selectedBodyPart} (${side})`;
        setPatientMedicationInfo({
          ...patientMedicationInfo,
          [name]: combinedValue,
        });
      }
    }
  };

  const handleOtherTextChange = (text) => {
    // Store as "Other: [text]"
    if (text.trim()) {
      setPatientMedicationInfo({
        ...patientMedicationInfo,
        [name]: `Other: ${text.trim()}`,
        [textFieldName]: text,
      });
    } else {
      setPatientMedicationInfo({
        ...patientMedicationInfo,
        [name]: "",
        [textFieldName]: "",
      });
    }
  };

  return (
    <>
      <div className="bg-transparent mb-2">
        <button
          style={{
            background: isOpen ? "#24518B" : "transparent",
            color: isOpen ? "#fff" : "#0C0544",
          }}
          className={`flex flex-col justify-start items-start w-full gap-4 py-4 border-b border-[#d4d4d4] ${
            isOpen ? "px-8 rounded-full border-b-0 mb-2" : "px-4 rounded-none "
          } text-left  focus:outline-none  transition-all duration-300 ease-linear`}
          onClick={() => onToggle(index)}
        >
          <div className="flex justify-between items-center w-full">
            <span
              className={`font-[700] font-mainFont 2xl:text-[1.3vw] xl:text-[1.3vw] lg:text-[1.3vw] md:text-[2.3vw] text-[3.2vw] ${
                isOpen ? "text-[#fff]" : "text-[#333333]"
              }`}
            >
              {title}
              {(hasSideSelection || textFieldOnly) && patientMedicationInfo[name] && (
                <span className="ml-2 text-[0.8em] opacity-80">
                  - {patientMedicationInfo[name]}
                </span>
              )}
            </span>

            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className={`w-5 h-5 transition-transform duration-500 ${
                isOpen ? "transform rotate-180" : ""
              }`}
            >
              <path
                d="M13.9999 3.33326L1.99994 3.33326C1.87845 3.33364 1.75936 3.36715 1.65549 3.43018C1.55163 3.49321 1.46692 3.58337 1.41048 3.69097C1.35404 3.79856 1.32802 3.9195 1.33521 4.04079C1.3424 4.16207 1.38253 4.27909 1.45128 4.37926L7.45128 13.0459C7.69994 13.4053 8.29861 13.4053 8.54794 13.0459L14.5479 4.37926C14.6174 4.2793 14.6581 4.16222 14.6657 4.04073C14.6733 3.91925 14.6474 3.79801 14.5909 3.69019C14.5344 3.58237 14.4495 3.49209 14.3453 3.42917C14.2411 3.36624 14.1217 3.33307 13.9999 3.33326Z"
                fill={isOpen ? "white" : "#0A1E44"}
              />
            </svg>
          </div>
        </button>
        <div
          className={`overflow-hidden transition-all duration-500 ease-linear ${
            isOpen ? "max-h-[800px] md:max-h-[600px] lg:max-h-[500px]" : "max-h-0"
          }`}
        >
          <div className="p-6 bg-transparent flex flex-col gap-4 overflow-y-auto max-h-[800px] md:max-h-[600px] lg:max-h-[500px]">
            {/* Text Field Only (for "Other" option) */}
            {textFieldOnly && (
              <div className="w-full">
                <input
                  type="text"
                  name={name}
                  value={patientMedicationInfo[name] || ""}
                  onChange={(e) => {
                    setPatientMedicationInfo({
                      ...patientMedicationInfo,
                      [name]: e.target.value,
                    });
                  }}
                  placeholder="Please specify..."
                  className="w-full px-4 py-2 rounded-full inputShado outline-none font-mainFont font-[500] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] placeholder:text-[#333333] border border-[#d4d4d4] placeholder:font-[400] text-black bg-[#f0f0f0]"
                />
              </div>
            )}

            {/* Body Part Selection - Only show if not textFieldOnly */}
            {!textFieldOnly && (
              <div className="flex flex-wrap justify-center items-center gap-3 md:gap-4 mb-4">
            {options.map((cur, id) => {
              // Determine if this field should be checkbox (multi-select) or radio (single select)
              // Checkbox fields: numbnessTingling, weaknessInNeck, joinSwellingStiffness
              // Radio fields: feverChills, morningStiffnessInBack, lossOfBladderControl, lossOfBowelControl, balanceRelatedProblems
              const isCheckboxField = ["numbnessTingling", "weaknessInNeck", "joinSwellingStiffness"].includes(name);
              const inputType = isCheckboxField ? "checkbox" : "radio";
              
              // For checkbox fields, check if value is in array
              // For radio fields, check if value matches exactly
              let isChecked;
              if (hasSideSelection && isCheckboxField) {
                // For checkbox fields with side selection, check if body part is in selectedBodyParts
                isChecked = selectedBodyParts.includes(cur);
              } else if (hasSideSelection) {
                // For radio fields with side selection
                isChecked = selectedBodyPart === cur;
              } else if (isCheckboxField) {
                // For checkbox fields without side selection
                const currentValue = patientMedicationInfo[name];
                isChecked = Array.isArray(currentValue) ? currentValue.includes(cur) : false;
              } else {
                // For radio fields without side selection
                isChecked = patientMedicationInfo[name] === cur;
              }
              
              return (
                <div key={id} className="flex justify-start items-center gap-2 md:gap-3 border border-[#d4d4d4] px-2 md:px-3 py-1.5 md:py-1 rounded-full">
                  <input
                    name={hasSideSelection ? `${name}_bodyPart` : name}
                    value={cur}
                    onChange={(e) => {
                      if (hasSideSelection) {
                        handleBodyPartChange(cur, isCheckboxField);
                      } else {
                        handleOnChange(e);
                      }
                    }}
                    type={inputType}
                    id={`section${index + 1}_bodyPart_${id}`}
                    checked={isChecked}
                    className="cursor-pointer"
                  />
                  <label
                    htmlFor={`section${index + 1}_bodyPart_${id}`}
                    className="font-mainFont font-[400] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1.2vw] text-[3.2vw] text-[#000] cursor-pointer break-words"
                  >
                    {cur}
                  </label>
                </div>
              );
            })}
              </div>
            )}

            {/* Side Selection (Right/Left/Both) - Show for each selected body part */}
            {hasSideSelection && (
              <>
                {isCheckboxField ? (
                  // For checkbox fields, show side selection for each selected body part
                  selectedBodyParts.map((bp, bpIndex) => (
                    <div key={bpIndex} className="mt-4 pt-4 border-t border-[#d4d4d4] mb-4 last:mb-0">
                      <p className="font-mainFont font-[500] 2xl:text-[1.1vw] xl:text-[1.1vw] lg:text-[1.1vw] md:text-[1.8vw] text-[3.2vw] text-[#333333] mb-3 break-words">
                        Select Side for <span className="font-[600]">{bp}</span>:
                      </p>
                      <div className="flex flex-wrap justify-center items-center gap-2 md:gap-3">
                        {sideOptions.map((side, id) => {
                          // Check if this body part already has this side selected
                          const currentValue = patientMedicationInfo[name];
                          const currentArray = Array.isArray(currentValue) ? currentValue : [];
                          const hasThisSide = currentArray.some(val => {
                            const match = val.match(/^(.+?)\s*\((.+?)\)$/);
                            if (match) {
                              return match[1].trim() === bp && match[2].trim() === side;
                            }
                            return false;
                          });
                          
                          return (
                            <div key={id} className="flex justify-start items-center gap-2 md:gap-3 border border-[#d4d4d4] px-2 md:px-3 py-1.5 md:py-1 rounded-full min-w-[80px] md:min-w-0">
                              <input
                                name={`${name}_side_${bp}`}
                                value={side}
                                onChange={() => handleSideChange(side, bp)}
                                type="radio"
                                id={`section${index + 1}_side_${bpIndex}_${id}`}
                                checked={hasThisSide}
                                className="cursor-pointer"
                              />
                              <label
                                htmlFor={`section${index + 1}_side_${bpIndex}_${id}`}
                                className="font-mainFont font-[400] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1.2vw] text-[3.2vw] text-[#000] cursor-pointer whitespace-nowrap"
                              >
                                {side}
                              </label>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  ))
                ) : (
                  // For radio fields, show side selection for single selected body part
                  selectedBodyPart && selectedBodyPart !== "Other" && (
                    <div className="mt-4 pt-4 border-t border-[#d4d4d4] mb-4">
                      <p className="font-mainFont font-[500] 2xl:text-[1.1vw] xl:text-[1.1vw] lg:text-[1.1vw] md:text-[1.8vw] text-[3.2vw] text-[#333333] mb-3">
                        Select Side:
                      </p>
                      <div className="flex flex-wrap justify-center items-center gap-2 md:gap-3">
                        {sideOptions.map((side, id) => (
                          <div key={id} className="flex justify-start items-center gap-2 md:gap-3 border border-[#d4d4d4] px-2 md:px-3 py-1.5 md:py-1 rounded-full min-w-[80px] md:min-w-0">
                            <input
                              name={`${name}_side`}
                              value={side}
                              onChange={() => handleSideChange(side)}
                              type="radio"
                              id={`section${index + 1}_side_${id}`}
                              checked={selectedSide === side}
                              className="cursor-pointer"
                            />
                            <label
                              htmlFor={`section${index + 1}_side_${id}`}
                              className="font-mainFont font-[400] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1.2vw] text-[3.2vw] text-[#000] cursor-pointer whitespace-nowrap"
                            >
                              {side}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  )
                )}
              </>
            )}

            {/* Other Text Field - Only show if "Other" is selected */}
            {hasOtherOption && selectedBodyPart === "Other" && (
              <div className="mt-4 pt-4 border-t border-[#d4d4d4]">
                <p className="font-mainFont font-[500] 2xl:text-[1.1vw] xl:text-[1.1vw] lg:text-[1.1vw] md:text-[1.1vw] text-[3.5vw] text-[#333333] mb-3">
                  Please specify:
                </p>
                <input
                  type="text"
                  value={patientMedicationInfo[textFieldName] || otherText || ""}
                  onChange={(e) => handleOtherTextChange(e.target.value)}
                  placeholder="Enter details..."
                  className="w-full px-4 py-2 rounded-full inputShado outline-none font-mainFont font-[500] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] placeholder:text-[#333333] border border-[#d4d4d4] placeholder:font-[400] text-black bg-[#f0f0f0]"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
